import { jsx as _jsx } from "react/jsx-runtime";
const Medal = ({ children }) => {
    return (_jsx("div", Object.assign({ className: 'flex-0 card h-100 bg-transparent' }, { children: _jsx("div", Object.assign({ className: 'card-body d-flex align-items-center justify-content-center p-0' }, { children: _jsx("div", Object.assign({ className: 'card d-flex justify-content-center align-items-center text-black bg-white border p-0 fs-3 fw-medium rounded-3', style: { width: '48px', height: '48px' } }, { children: children })) })) })));
};
export default Medal;
